var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3768_1036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 6.09375C12.1875 7.43848 11.751 8.68066 11.0156 9.68848L14.7246 13.4004C15.0908 13.7666 15.0908 14.3613 14.7246 14.7275C14.3584 15.0938 13.7637 15.0938 13.3975 14.7275L9.68848 11.0156C8.68067 11.7539 7.43848 12.1875 6.09375 12.1875C2.72754 12.1875 0 9.45996 0 6.09375C0 2.72754 2.72754 0 6.09375 0C9.45996 0 12.1875 2.72754 12.1875 6.09375ZM6.09375 10.3125C6.64776 10.3125 7.19635 10.2034 7.7082 9.99137C8.22004 9.77936 8.68511 9.4686 9.07686 9.07686C9.4686 8.68511 9.77936 8.22004 9.99137 7.7082C10.2034 7.19635 10.3125 6.64776 10.3125 6.09375C10.3125 5.53974 10.2034 4.99115 9.99137 4.4793C9.77936 3.96746 9.4686 3.50239 9.07686 3.11064C8.68511 2.7189 8.22004 2.40815 7.7082 2.19613C7.19635 1.98412 6.64776 1.875 6.09375 1.875C5.53974 1.875 4.99115 1.98412 4.4793 2.19613C3.96746 2.40815 3.50239 2.7189 3.11064 3.11064C2.7189 3.50239 2.40815 3.96746 2.19613 4.4793C1.98412 4.99115 1.875 5.53974 1.875 6.09375C1.875 6.64776 1.98412 7.19635 2.19613 7.7082C2.40815 8.22004 2.7189 8.68511 3.11064 9.07686C3.50239 9.4686 3.96746 9.77936 4.4793 9.99137C4.99115 10.2034 5.53974 10.3125 6.09375 10.3125Z",
    fill: "#AAAABB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3768_1036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.bb712ec857efb0f5fb9cba0fb140cf14.svg";
export { ForwardRef as ReactComponent };